/**
 * The five fixed windows the UI surfaces. `24h` is for
 * incident-investigation density; the others span the typical DMARC
 * monitoring cadences. No "custom" range in Phase 1 — the UI
 * complexity of a date picker isn't justified by the use cases
 * we've seen, and a fixed enum keeps the URL param small and
 * unambiguous.
 *
 * If "custom" becomes a need, extend this type as a discriminated
 * union — the store + selector were structured so a single
 * `Window | { kind: "custom"; since: string; until: string }` swap
 * is mechanical.
 */
export type TimeWindow = "24h" | "7d" | "30d" | "90d";

export const TIME_WINDOWS = ["24h", "7d", "30d", "90d"] as const;

export function isTimeWindow(value: unknown): value is TimeWindow {
  return (
    typeof value === "string" &&
    (TIME_WINDOWS as readonly string[]).includes(value)
  );
}

/**
 * Trailing-days count for an API call's `windowDays` query param.
 * The API expresses windows in days; the UI in human shorthand.
 */
export function timeWindowToDays(window: TimeWindow): number {
  switch (window) {
    case "24h":
      return 1;
    case "7d":
      return 7;
    case "30d":
      return 30;
    case "90d":
      return 90;
  }
}
